import FetchBeneficiaryWorkflowRuns from '@Application/WorkflowRuns/BeneficiaryWorkflowRuns/Queries/FetchBeneficiaryWorkflowRuns';
import fetchBeneficiaryWorkflowRuns from '@Application/WorkflowRuns/BeneficiaryWorkflowRuns/fetchBeneficiaryWorkflowRuns';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import type BeneficiaryWorkflowRunsListView from '@UI/Store/WorkflowRuns/Views/BeneficiaryWorkflowRunsListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import type { UseStoreQueryResult } from '@verclam/synapse';

/**
 * The preparations of one dossier. Every reader of this list declares it here, so they share one cache
 * entry and one request.
 */
const useSubjectWorkflowRuns = (
	subject: SubjectAddress,
): UseStoreQueryResult<BeneficiaryWorkflowRunsListView | null> => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;

	return useStoreQuery({
		selector: (state) => state.workflowRunsStore.beneficiaryWorkflowRuns,
		stopOn: (value) => value !== null && value.facilityId === facilityId && value.isFor(subject),
		query: () =>
			dispatch(fetchBeneficiaryWorkflowRuns(new FetchBeneficiaryWorkflowRuns(facilityId, subject))),
		deps: [facilityId, subject],
	});
};

export default useSubjectWorkflowRuns;
